import { Typography } from "antd";
import { useWidgetData } from "../Contexts/dashboardHooks";
import type { BodyMapComponentSpec } from "../Processing/types";

const { Text } = Typography;

function humanizeQuestionKey(key: string): string {
  return key
    .replace(/^bodymap_/, "")
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

function buildInfoContent(spec: BodyMapComponentSpec) {
  const misc = spec.body_map_builder_misc ?? {};
  let dateLabel: string;
  if (misc.dateMode === "absolute") {
    dateLabel = misc.fixedDate || "—";
  } else {
    const offset = misc.dateOffset ?? 0;
    const abs = Math.abs(offset);
    dateLabel = offset === 0 ? "Today" : `${abs} day${abs === 1 ? "" : "s"} ago`;
  }

  const title = spec.display.title || "Body Map";

  return (
    <div style={{ maxWidth: 360, fontSize: 12, lineHeight: 1.6 }}>
      <div style={{ marginBottom: 8 }}>
        <Text strong style={{ fontSize: 12 }}>{title}</Text>
        <div style={{ paddingLeft: 4, color: "rgba(0,0,0,0.65)" }}>
          <div>Type: {humanizeQuestionKey(spec.question_key)}</div>
          <div>Date: {dateLabel}</div>
        </div>
      </div>
    </div>
  );
}

export function BodyMapInfo({ id }: { id: string }) {
  const data = useWidgetData(id);
  if (!data || data.type !== "body_map") return null;
  return buildInfoContent(data.spec);
}
